import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ServiceList from './service_list';
import ServiceDetail from './service_detail';

class Serivce extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ServiceList/>;
    }else{
      if(params.id===undefined){
        view = <ServiceDetail/>;
      }else{
        view = <ServiceDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Serivce.contextTypes = {
  router: PropTypes.object
};

export default Serivce;
